import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = {
  key: 0,
  class: "login-header"
}
const _hoisted_4 = {
  key: 1,
  class: "login-header"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "identifier" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "password" }
const _hoisted_11 = { class: "password-input" }
const _hoisted_12 = ["type", "disabled"]
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 3,
  class: "verification-form"
}
const _hoisted_18 = { class: "code-inputs" }
const _hoisted_19 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "spinner"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "resend" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "back-to-login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.showVerification)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: "/logo192.png",
              alt: "OKOLISY",
              class: "logo"
            }, null, -1),
            _createElementVNode("h1", null, "Administration OKOLISY", -1),
            _createElementVNode("p", null, "Connectez-vous pour accéder au tableau de bord", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: "/logo192.png",
              alt: "OKOLISY",
              class: "logo"
            }, null, -1),
            _createElementVNode("h1", null, "🔐 Vérification requise", -1),
            _createElementVNode("p", null, [
              _createTextVNode("Un code de sécurité a été envoyé à "),
              _createElementVNode("strong", null, "okolisyadmin@gmail.com")
            ], -1),
            _createElementVNode("p", { class: "security-note" }, "⚠️ Ce code est demandé à chaque connexion pour des raisons de sécurité", -1)
          ]))])),
      (!_ctx.showVerification)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"])),
              class: "login-form"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
                  _cache[10] || (_cache[10] = _createTextVNode(" Email ou Téléphone ", -1))
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "identifier",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.identifier) = $event)),
                  placeholder: "example@gmail.com",
                  required: "",
                  disabled: _ctx.loading
                }, null, 8, _hoisted_8), [
                  [_vModelText, _ctx.form.identifier]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, { icon: "lock" }),
                  _cache[11] || (_cache[11] = _createTextVNode(" Mot de passe ", -1))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showPassword ? 'text' : 'password',
                    id: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                    placeholder: "••••••••",
                    required: "",
                    disabled: _ctx.loading
                  }, null, 8, _hoisted_12), [
                    [_vModelDynamic, _ctx.form.password]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "toggle-password",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                    }, null, 8, ["icon"])
                  ])
                ])
              ]),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_font_awesome_icon, { icon: "exclamation-circle" }),
                    _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "submit",
                class: "login-btn",
                disabled: _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, "Se connecter"))
              ], 8, _hoisted_14)
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "verification-header" }, [
              _createElementVNode("p", null, "Entrez le code à 4 chiffres reçu par email")
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (digit, index) => {
                return _withDirectives(_createElementVNode("input", {
                  key: index,
                  ref_for: true,
                  ref: "codeInputs",
                  type: "text",
                  maxlength: "1",
                  class: "code-digit",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.codeDigits[index]) = $event),
                  onInput: ($event: any) => (_ctx.handleCodeInput(index, $event)),
                  onKeydown: ($event: any) => (_ctx.handleCodeKeydown(index, $event)),
                  onPaste: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
                }, null, 40, _hoisted_19), [
                  [_vModelText, _ctx.codeDigits[index]]
                ])
              }), 64))
            ]),
            (_ctx.verificationError)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["error-message", { success: _ctx.verificationSuccess }])
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.verificationSuccess ? 'check-circle' : 'exclamation-circle'
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.verificationError), 1)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "verify-btn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.verifyCode && _ctx.verifyCode(...args))),
              disabled: _ctx.verifying
            }, [
              (_ctx.verifying)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, "Vérifier et se connecter"))
            ], 8, _hoisted_20),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "resend-btn",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args))),
                disabled: _ctx.resending
              }, _toDisplayString(_ctx.resending ? 'Envoi...' : '📧 Renvoyer le code'), 9, _hoisted_24)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                class: "back-btn",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goBackToLogin && _ctx.goBackToLogin(...args)))
              }, " ← Retour à la connexion ")
            ])
          ])),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "login-footer" }, [
        _createElementVNode("a", { href: "/" }, "Retour au site")
      ], -1))
    ])
  ]))
}